import { Skeleton } from '../../../components/Skeleton';
import { SummaryStatisticsSkeleton } from './SummaryStatistics';

export function PatientDashboardSkeleton() {
  return (
    <div className="flex flex-col">
      <div className="flex flex-col items-center justify-between gap-2 md:flex-row md:gap-0">
        <div className="flex flex-col items-center md:items-start">
          <Skeleton className="h-[40px] w-[250px]" />
          <Skeleton className="mt-2 h-[20px] w-[150px]" />
        </div>
        <div className="flex gap-5">
          <Skeleton className="h-[50px] w-[50px] md:w-[180px]" />
          <Skeleton className="h-[50px] w-[50px] md:w-[180px]" />
        </div>
      </div>
      <div className="flex flex-col items-center justify-between gap-4 pt-4 md:flex-row md:gap-0">
        <Skeleton className="h-[40px] w-full md:w-[400px]" />

        <div className="flex flex-col gap-4 md:flex-row md:gap-0">
          <Skeleton className="me-4 h-[40px] w-[350px]" />
          <Skeleton className="h-[40px] w-[350px]" />
        </div>
      </div>

      <SummaryStatisticsSkeleton />

      <div className="flex justify-center gap-5 pb-5">
        <Skeleton className="h-[425px] w-2/3" />
        <Skeleton className="h-[425px] w-1/3" />
      </div>

      <div className="flex justify-center gap-5 pb-5">
        <Skeleton className="h-[425px] w-2/3" />
        <Skeleton className="h-[425px] w-1/3" />
      </div>

      <div className="flex justify-center gap-5 pb-5">
        <Skeleton className="h-[425px] w-2/3" />
        <Skeleton className="h-[425px] w-1/3" />
      </div>

      <div className="flex justify-center gap-5 pb-5">
        <Skeleton className="h-[425px] w-full" />
      </div>

      <div className="flex justify-center gap-5 pb-5">
        <Skeleton className="h-[425px] w-full" />
        <Skeleton className="h-[425px] w-full" />
      </div>

      <div className="flex justify-center gap-5 pb-5">
        <Skeleton className="h-[600px] w-full" />
      </div>
    </div>
  );
}
